import { useQueryClient } from '@tanstack/react-query';
import { allocationQueries } from '../queries';

/** Para quem muda dado que as telas de alocação mostram (ex.: nome e cor das tags). */
export function useInvalidateAllocations() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: allocationQueries.all() });
}
